<template>
    <div class="popup-login">
        <van-popup v-model="popupOpen" position="top" :overlay="false" class="popupOpen">
            <van-nav-bar :title="popupTitle" :border="false" @click-right="clickPopup">
                <van-icon name="manager" slot="right"/>
            </van-nav-bar>
        </van-popup>
        <van-popup v-model="dialogOpen" style="width: 85%;" :close-on-click-overlay="false" class="dialogOpen">
            <div class="header">
                <div class="header-left">{{dialogTitle}}</div>
                <div class="header-right">
                    <van-icon name="cross" slot="right" @click="clickDialog"/>
                </div>
            </div>
            <div style="text-align: center;margin: 1rem 1rem">
                <template v-if="form.loginType=='pwd'">
                    <van-field v-model="form.account" placeholder="输入登录名或手机号"/>
                    <van-field v-model="form.pwd" type="password" placeholder="输入密码"/>
                </template>
                <template v-if="form.loginType=='code'">
                    <van-field v-model="form.phone" placeholder="手机号"/>
                    <van-field v-model="form.code" placeholder="请输入短信验证码">
                        <van-button slot="button" size="small" @click='sendCode'
                                    :disabled="timerCodeBtn.time > 0"
                                    :plain="timerCodeBtn.time > 0"
                        >
                            {{timerText}}
                        </van-button>
                    </van-field>
                </template>
                <van-button square type="primary" @click="clickLogin">登录</van-button>
                <van-row class="register" gutter="40" >
                    <van-col span="14">没有账号？免费
                        <router-link to="/register">注册</router-link>
                    </van-col>
                    <van-col span="10">
                        <router-link to="/newPassword"> 忘记密码</router-link>
                    </van-col>
                </van-row>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'popupLogin',
        data() {
            return {
                popupTitle: '此页面服务需要登录',
                dialogTitle: '登录',
                dialogOpen: false,
                popupOpen: false,
                form: {
                    phone: null,
                    code: null,
                    account: null,
                    pwd: null,
                    loginType: 'pwd',
                },
                timerCodeBtn: {
                    time: 0,
                    disabled: false
                }
            }
        },
        computed: {
            timerText: function () {
                return this.timerCodeBtn.time > 0 ? this.timerCodeBtn.time + 'S再获取' : '发送验证码';
            },
            ...mapGetters(["popupLogin"]),
            popupLoginCompute() {
                return this.popupLogin
            }
        },
        created() {

        },
        watch: {
            popupLoginCompute(newValue, lodValue) {
                if (newValue) {
                    this.dialogOpen = true
                    //this.popupOpen = false
                } else {
                    this.dialogOpen = false
                    //this.popupOpen = false
                }
            }
        },
        methods: {
            sendCode() {
                if (!this.$myUtil.mobile(this.form.phone)) {
                    this.$toast("手机号不正确")
                    return
                }
                this.$http({
                    url: '/code/send',
                    params: this.form
                }).then((result) => {
                    this.timerCodeBtn.time = 90
                    this.timer()
                }).catch((error) => {
                })
            },
            clickPopup() {
                this.dialogOpen = true
              //  this.popupOpen = false
            },
            clickDialog() {
                this.$store.dispatch('openPopupLogin',false)
                //this.dialogOpen = false
                //this.popupOpen = true
            },
            clickLogin() {

                if (this.form.loginType == 'pwd') {
                    if (!this.$myUtil.isLegalPwd(this.form.pwd)) {
                        this.$toast("密码不正确")
                        return
                    }
                }

                if (this.form.loginType == 'code') {
                    if (!this.$myUtil.mobile(this.form.phone)) {
                        this.$toast("手机号不正确")
                        return
                    }
                }

                this.$http({
                    url: '/user/login',
                    method: 'post',
                    data: this.form
                }).then((result) => {
                    this.$store.dispatch('setToken', result.data)
                    window.location.reload()
                }).catch((error) => {
                    debugger
                })
            },
            stop: function () {
                this.timerCodeBtn.time = 0;
                this.timerCodeBtn.disabled = false;
            },
            timer: function () {
                if (this.timerCodeBtn.time > 0) {
                    this.timerCodeBtn.time--
                    setTimeout(this.timer, 1000)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .popupOpen .van-nav-bar {
        background-color: rgba(0, 0, 0, 0.8);
        color: #fff;
    }

    .header {
        height: 3.8rem;
        position: relative;
        text-align: center;
        line-height: 3.8rem;
    }

    .header-left {
        left: 1.25rem;
    }

    .header-right {
        width: 3rem;
        right: 1rem;
    }

    .header-left, .header-right {
        bottom: 0;
        font-size: 1.4rem;
        position: absolute;
    }

    .van-button {
        width: 90%;
        margin: 3rem 0 1rem 0rem;
        background-color: #ee9900;
        /*border-radius: 0.5rem;*/
    }

    .van-button--primary {
        border: 0;
    }

    .register {
        a{
            color: #ee9900;
        }
        color: #bfbfbf;
        font-size: 1.1rem;
        margin-bottom: 3rem;
    }
</style>
